import request from "@/utils/request";

// 查询业务员审核列表
export function getCsoMemberPage(data) {
  return request({
    url: "/shop/hg/csoMember/audit/page",
    method: "GET",
    params: data,
  });
}
// 查看CSO业务员
export function csoMemberDetail(id) {
  return request({
    url: `/shop/hg/csoMember/detail/${id}`,
    method: "get",
    params: {},
  });
}
// 审核业务员
export function auditCsoMember(data) {
  return request({
    url: "/shop/hg/csoMember/audit",
    method: "POST",
    data,
  });
}
// 获取 人员资质 列表
export function csoResourceUserPage(data) {
  return request({
    url: `/shop/hg/csoResourceUser/pagePlat`,
    method: "get",
    params: data,
  });
}
// 查询人员资质详情
export function csoResourceUserDetail(id) {
  return request({
    url: `/shop/hg/csoResourceUser/detail/${id}`,
    method: "get",
    params: {},
  });
}
// 审核 CSO 提交的人员资质
export function auditCsoResourceUser(data) {
  return request({
    url: "/shop/hg/csoResourceUser/audit",
    method: "POST",
    data,
  });
}
// 导出人员资质
export function csoResourceUserExportPlat(data) {
  return request({
    url: `/shop/hg/csoResourceUser/exportPlat`,
    method: "get",
    params: data,
    responseType: "blob",
  }).then((response) => {
    // console.log(response,'res')
    // 处理返回的文件流
    const blob = response.data;
    if ((blob && blob.size === 0) || response.size == 0) {
      Message.warning("内容为空，无法下载");
      return;
    }
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    const contentDisposition = response.headers["content-disposition"];
    const fileName = decodeURIComponent(
      contentDisposition.substring(contentDisposition.indexOf("=") + 1)
    );
    link.download = "人员资质导出" + fileName;
    document.body.appendChild(link);
    link.click();
    window.setTimeout(function () {
      URL.revokeObjectURL(blob);
      document.body.removeChild(link);
    }, 0);
  });
}

// 完税凭证
export function csoDutyPaidProofPlatformPage(data) {
  return request({
    url: `/shop/csoDutyPaidProof/platform/page`,
    method: "get",
    params: data,
  });
}
// 完税凭证列表
export function csoDutyPaidProofSubClassPage(data) {
  return request({
    url: `/shop/csoDutyPaidProof/subclass/page`,
    method: "get",
    params: data,
  });
}
// 完税凭证审核列表
export function csoDutyPaidProofAllSubClassPage(data) {
  return request({
    url: `/shop/csoDutyPaidProof/allSubclass/page`,
    method: "get",
    params: data,
  });
}

// 查看完税凭证详情
export function csoDutyPaidProofDetail(id) {
  return request({
    url: `/shop/csoDutyPaidProof/${id}`,
    method: "get",
    params: {},
  });
}
// 审核凭证
export function auditCsoDutyPaidProof(data) {
  return request({
    url: "/shop/csoDutyPaidProof",
    method: "PUT",
    data,
  });
}
